export const procedureTypes = {
  MARKDOWN: 'Markdown',
  PDF: 'Pdf',
};
